import { render, staticRenderFns } from "./CruiseDetail.vue?vue&type=template&id=25713034&scoped=true"
import script from "./CruiseDetail.vue?vue&type=script&lang=js"
export * from "./CruiseDetail.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetail.vue?vue&type=style&index=0&id=25713034&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25713034",
  null
  
)

export default component.exports